  // src/api/aiNotesToContent.js
  import axios from 'axios';

  const AI_COMPOSITION_API_URL = '/api/compose-content';

  /**
   * Send selected sticky notes to AI for composition
   * @param {Array} stickies - Array of sticky notes [{ id, type, content }]
   * @param {string} task - The task description for AI processing
   * @returns {Promise<string>} - The AI-generated response
   */
export const sendNotesToAI = async (stickies, task = "Create a single, cohesive passage based on these notes.") => {
  try {
    if (!stickies.length) {
      console.warn("No stickies selected for AI composition.");
      return "";
    }

    console.log("Sending AI Composition Request with", stickies.length, "stickies");

    const payload = {
      stickies: stickies.map((sticky, index) => ({
        id: sticky.id,
        type: sticky.type,
        content: sticky.content,
        displayNumber: index + 1
      })),
      task
    };

    const response = await axios.post(AI_COMPOSITION_API_URL, payload, {
      withCredentials: true,
      headers: {
        'Content-Type': 'application/json'
      }
    });

    console.log("AI Composition Response received:", response.data);

    return response.data.output || "";

  } catch (error) {
    console.error("Error sending notes to AI:", error);

    // ✅ Match old behavior from stickyAiApi.js
    if (error.response?.status === 402) {
      console.warn("Token balance error");
      throw new Error("Insufficient token balance");
    }

    if (error.response?.status === 401) {
      console.warn("Authentication error");
      throw new Error("Authentication failed");
    }

    throw new Error("AI composition failed");
  }
};
